// 定制旅行State Module
import {
  FETCH_CUSTOM_FILTER_INFO,
  FETCH_CUSTOM_ROUTE_LIST,
  FETCH_CUSTOM_ROUTE_CATEGORY_LIST,
  FETCH_SPORTS_RAIDERS_LIST,
  FETCH_CUSTOM_ORDER_SERVICES,
  FETCH_CUSTOM_ROUTE_BY_ID,
  FETCH_CUSTOM_ORDER_INTRO,
  FETCH_RECOMMEND_CUSTOM_LIST,
} from '../mutation-types'
import parse from '../../utils/emoji'

const initialState = {
  customs: [],            // 推荐线路
  customRoute: {},        // 某条线路
  categories: [],         // 频道栏
  routeList: [],          // 城市
  filterInfo: {},         // 筛选信息(只限于观赛选项)
  topicList: [],          // 对应线路达人分享
  services: [],           // 对应定制需求
  ads: [],                // 广告
}

const initialMutations = {
  [FETCH_CUSTOM_ROUTE_CATEGORY_LIST](state, data) {
    state.categories = data.categories
  },
  [FETCH_CUSTOM_FILTER_INFO](state, data) {
    state.filterInfo.categories = data.categories
    state.filterInfo.citys = data.citys
    state.filterInfo.labels = data.labels
  },
  [FETCH_CUSTOM_ROUTE_LIST](state, data) {
    state.routeList = data.routeList
  },
  [FETCH_SPORTS_RAIDERS_LIST](state, data) {
    state.topicList = data.topicList.map((topicList) => {
      topicList.content = parse(topicList.content)
      topicList.comments = topicList.comments.map((comment) => {
        comment.content = parse(comment.content)
        return comment
      })
      topicList.unfold = false
      return topicList
    })
  },
  [FETCH_CUSTOM_ORDER_SERVICES](state, data) {
    state.services = data.services
  },
  [FETCH_CUSTOM_ROUTE_BY_ID](state, data) {
    state.customRoute = data
  },
  [FETCH_CUSTOM_ORDER_INTRO](state) {
    window.console.log(state)
  },
  [FETCH_RECOMMEND_CUSTOM_LIST](state, data) {
    state.customs = data.routeList
  },
}

export default {
  state: initialState,
  mutations: initialMutations,
}



// WEBPACK FOOTER //
// ./client/vuex/modules/custom.js